import{Link} from "react-router-dom"
import { ISettingsLinksProps } from "./SettingsLinks";

import rightarrow from "../../assets/icons/rightarrow.svg"

export const View = (props: ISettingsLinksProps) => { //or put inside <= this curlybraces
    const { iconLeft, iconRight, title, subtitle, hideDivider, urlTarget } =
    props;
  return (
    <div className="container">
    <Link to={urlTarget} className="flex-container linkContainer">
      <div className="flex-container labelContainer">
        {iconLeft}

        <div className="titleContainer">
          <p className="title font-ctm--medium">{title}</p>
          {subtitle ? <span className="subtitle">{subtitle}</span> : null}
        </div>
      </div>

      <div className="iconRightContainer">
        {!iconRight ? (
          <img src={rightarrow} alt="link icon" className="iconRight" />
        ) : null}
        {iconRight && iconRight}
      </div>
    </Link>
  </div>
  );
};
